<ul class="file-download-three-action-list">
    <li class="" *ngFor="let file of files; index as i">
        <core-file-download-three-action-list-item
            [file]="file"
            [marked]="isMarked(file)"
            [actionOneText]="actionOneText"
            [actionOneStyle]="actionOneStyle"
            [actionTwoText]="actionTwoText"
            [actionTwoStyle]="actionTwoStyle"
            [actionThreeText]="actionThreeText"
            [actionThreeStyle]="actionThreeStyle"
            [bubble]="bubbles && getBubbleText(i)!=''"
            [bubbleNumber]="getBubbleText(i)"
            (actionOneClick)="onActionOneClick(file)"
            (actionTwoClick)="onActionTwoClick(file)"
            (actionThreeClick)="onActionThreeClick(file)"
            (bubbleClick)="onBubbleClick(file)"
        >
        </core-file-download-three-action-list-item>
    </li>
</ul>
